export default (array, key = 'id') => {
  return array.reduce((sum, a) => {
    const keyObj = a[key]
    return {
      ...sum,
      [keyObj]: a
    }
  }, {})
}
